import React, { Component } from "react";

export default class offCampusApartments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apartmentData: [
        {
          area: "Downtown",
          apartments: [
            {
              name: "Georgia Heights",
              link: "https://www.georgiaheights.com/",
              comments: "Walking distance to campus",
            },
            {
              name: "The Standard",
              link: "https://www.thestandardathens.com/",
              comments: "Walking distance to campus",
            },
            {
              name: "The Uncommon",
              pricing: "$$",
              link: "https://www.uncommonathens.com/",
              comments: "Walking distance to campus",
            },
          ],
        },
        {
          area: "NORTH ATHENS",
          apartments: [
            {
              name: "Whistlebury Walk",
              pricing: "$$",
              link: "https://www.apartmentguide.com/apartments/Georgia/Athens/Whistlebury-Walk/100021255/",
              comments: "Walking distance to campus",
            },

            {
              name: "Whistlebury Apartments",
              pricing: "$$",
              comments: "Walking distance to campus",
            },
            {
              name: "The Lodge of Athens",
              pricing: "$$",
              link: "https://www.thelodgeofathens.com/",
              comments: "Has a shuttle system to campus & downtown",
            },
          ],
        },
        {
          area: "CHICOPEE-DUDLEY",
          apartments: [
            {
              name: "Steeplechase Apartments",
              link: "https://collegehouse.com/properties/394-oconee-street-athens-ga-30601",
              comments: "Walking distance to campus & downtown",
            },
            {
              name: "909 Broad Apartments",
              comments: "Walking distance to campus & downtown",
            },
            {
              name: "River Mill",
              pricing: "$$",
              link: "https://www.americancampus.com/student-apartments/ga/athens/river-mill",
              comments: "Walking distance to campus & downtown. Has 6 month leasing options",
            },
            {
              name: "The Mark",
              link: "https://themarkathens.landmark-properties.com/",
              comments: "Walking distance to campus & downtown",
            },
            {
              name: "Eclipse on Broad",
              link: "https://www.eclipseonbroad.com/",
              comments: "Walking distance to campus & downtown",
            },
            {
              name: "WaterFord Place",
              pricing: "$$",
              link: "https://www.apartments.com/waterford-place-student-housing-athens-ga/7ncp40z/",
              comments: "Walking distance to campus & downtown",
            },
            {
              name: "The Flats",
              pricing: "$$",
              comments: "Walking distance to campus",
            },
          ],
        },
        {
          area: "EAST SIDE",
          apartments: [
            {
              name: "Polo Club Athens Apartments",
              pricing: "$",
              link: "https://www.poloclubuga.com/",
              comments: "On Athens Transit Line",
            },
            {
              name: "IKON at Athens",
              pricing: "$",
              link: "https://www.ikonathens.com/",
              comments: "On Athens Transit Line. Weekend downtown shuttle",
            },
            {
              name: "Woodlands of Athens",
              link: "https://www.thelodgeofathens.com/",
              comments: "On Athens Transit Line",
            },
            {
              name: "The Reserve at Athens",
              pricing: "$",
              link: "https://www.reserveatathens.com/",
              comments: "On Athens Transit Line.",
            },
            {
              name: "Cambridge Apartments",
              link: "https://www.cambridgeapthomes.com/",
              comments: "Walking distance to Publix",
            },
            {
              name: "Shoal Creek",
              pricing: "$$",
              link: "https://www.apartments.com/shoal-creek-apartments-athens-ga/j3wm364/",
              comments: "On Athens Transit Line.",
            },
          ],
        },
        {
          area: "Baxter Street",
          apartments: [
            {
              name: "Tanyard Condominiums",
              link: "http://joinermanagement.com/tanyard-condominiums/",
              comments: "Walking distance to campus. Close access to UGA Transit system",
            },
            {
              name: "Towne Club",
              pricing: "$$",
              link: "https://www.clubproperties.com/",
              comments: "Walking distance to campus. Close access to UGA Transit system",
            },
            {
              name: "Bromsgrove Apartments",
              pricing: "$$",
              link: "http://www.bromsgroveapt.com/",
              comments: "Walking distance to campus. Close access to UGA Transit system",
            },
            {
              name: "University Garden Apartments",
              pricing: "$$",
              link: "https://www.universitygardenapts.com/university-garden-athens-ga",
              comments: "Walking distance to campus",
            },
          ],
        },
        {
          area: "Macon Highway Area",
          apartments: [
            {
              name: "The Park at Athens",
              pricing: "$",
              link: "https://thepark-athens.com/",
              comments: "On Athens Transit Line",
            },
            {
              name: "Athens Ridge Clubhouse",
              pricing: "$$",
              link: "https://www.athensridge.com/",
              comments: "Has shuttle system to campus and downtown",
            },
            {
              name: "Riverbend Club Apartments",
              pricing: "$",
              link: "https://www.apartments.com/riverbend-club-apartments-athens-ga/2ngg9wc/",
              comments: "NA",
            },
            {
              name: "River Club",
              pricing: "$",
              link: "https://www.facebook.com/RiverClubAthens/",
              comments: "Bus stop on-site, service to UGA",
            },
            {
              name: "The Redlands Apartments",
              pricing: "$",
              link: "https://www.theredlandapts.com/",
              comments: "On Athens Transit Line",
            },
          ],
        },
        {
          area: "EPPS BRIDGE",
          apartments: [
            {
              name: "The Bluffs at Epps Bridge",
              pricing: "$$",
              link: "https://www.thebluffsateppsbridge.com/",
              comments: "On Athens Transit Line",
            },
          ],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.state.apartmentData.map((apData, index) => {
          return (
            <React.Fragment key={"apartmentData" + index}>
              <section>
                <header className="offCampusAreaName">{apData.area}</header>
                <div className="offCampusTableContainer">
                  <table className="table offCampusTable">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Apartment</th>
                        <th scope="col">General Pricing</th>
                        <th scope="col">Link</th>
                        <th scope="col">Comments</th>
                      </tr>
                    </thead>
                    <tbody>
                      {apData.apartments.map((apt, index) => {
                        return (
                          <React.Fragment key={"apt" + index}>
                            <tr>
                              <th scope="row">{index + 1}</th>
                              <td>{apt.name}</td>
                              <td className="aptPricing">{apt.pricing ? apt.pricing : "$$$"}</td>
                              <td>
                                {apt.link ? (
                                  <a href={apt.link} target="_blank" rel="noreferrer">
                                    Link
                                  </a>
                                ) : (
                                  "NA"
                                )}
                              </td>
                              <td>{apt.comments}</td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </section>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
}
